import axios from "axios";
import apiUrl from "../../configs/api";
import { getSessionToken } from "../authManagement/sessionToken";

const httpClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  timeout: 30000,
});

httpClient.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  const url = config.url || "";
  if (url.includes("/Email/Search")) {
    config.timeout = config.timeout || 55000;
  } else if (url.includes("/Commodity")) {
    // A page of 10 verified companies is allowed to take up to 25s.
    config.timeout = config.timeout || 25000;
  }
  return config;
});

export default httpClient;
